module.exports = __webpack_public_path__ + "c726573312a67b8d91ee0a424c0f2647.svg";